export default __webpack_public_path__ + "static/media/mountain.8473fa76.svg";